// extracted by mini-css-extract-plugin
module.exports = {"div":"FacialRecognitionInstructions_div_2lkXL"};